import initialState from '../initialState';
import {
  ADD_PRODUCT_ITEM,
  DECREASE_PRODUCT_QUANTITY,
  DELETE_PRODUCT_ITEM,
  INCREASE_PRODUCT_QUANTITY,
  RESET_PRODUCT_QUANTITY
} from './actionTypes';

const productItemReducer = (state = initialState.productItems, action) => {
  switch (action.type) {
    case ADD_PRODUCT_ITEM:
      return [...state, action.payload];
    case DELETE_PRODUCT_ITEM:
      return state.filter(item => item.productId !== action.payload);
    case INCREASE_PRODUCT_QUANTITY:
      // const findItem = state.find(item => item.productId === action.payload);
      // findItem.productQuantity = findItem.productQuantity + 1;
      // const otherItems = state.filter(
      //   item => item.productId !== action.payload
      // );
      // return [...otherItems, findItem];
      return state.map(item => {
        if (item.productId === action.payload) {
          item.productQuantity = item.productQuantity + 1;
        }
        return item;
      });

    case DECREASE_PRODUCT_QUANTITY:
      return state.map(item => {
        if (item.productId === action.payload) {
          item.productQuantity = item.productQuantity - 1;
        }
        return item;
      });
    case RESET_PRODUCT_QUANTITY:
      return state.map(item => {
        if (item.productId === action.payload) {
          item.productQuantity = item.defaultProductQuantity;
        }
        return item;
      });
    default:
      return state;
  }
};

export default productItemReducer;
